import React, { useEffect, useState } from 'react';

import { Cancel, CheckCircle } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
import moment from 'moment';

const WorkExperiene = ({
  data,
  setData,
  workExperience,
  setDisableSave,
  disableSave,
}) => {
  const [verify, setVerify] = useState({});
  const [workExperieneData, setWorkExperieneData] = useState([]);

  const getDuration = (startDate, endDate) => {
    const start = moment(startDate);
    const end = moment(endDate || moment());

    const years = end.diff(start, 'year');
    start.add(years, 'years');

    const months = end.diff(start, 'months');
    start.add(months, 'months');

    return years + ' years ' + months + ' months ';
  };

  useEffect(() => {
    if (Object.keys(verify).length > 0) {
      if (workExperience?.length === Object.keys(verify).length) {
        setDisableSave({ ...disableSave, workExperience: false });
      } else {
        setDisableSave({ ...disableSave, workExperience: true });
      }
    }
  }, [verify]);

  useEffect(() => {
    if (workExperieneData.length > 0) {
      setData({
        ...data,
        workExperience: [...workExperieneData],
      });
    }
  }, [workExperieneData]);

  return (
    <>
      <div className=' shadow-xl rounded-lg col-span-3'>
        <div className='bg-gray-200 py-2 px-4 text-[#134F5C] text-base font-semibold'>
          Work Experience
        </div>
        {/* </div> */}

        <div className='flex flex-col space-y-10 justify-center w-full py-6'>
          {workExperience?.length > 0 &&
            workExperience.map((exp, index) => {
              return (
                <div className='flex items-center gap-14  px-4' key={index}>
                  <span className=' flex items-center w-3/4'>
                    <span className='ml-2'>
                      <div className=' flex flex-col space-y-1'>
                        <div className=' opacity-80 text-base'>
                          {exp.jobTitleName}
                        </div>
                        <div className=' opacity-60 text-sm'>
                          {exp.companyName}
                        </div>
                        <div className='opacity-50'>
                          {moment(exp.startDate).format('MMM YYYY')} -{' '}
                          {(exp.endDate &&
                            moment(exp.endDate).format('MMM YYYY')) ||
                            'Present'}
                          {' , '}
                          {getDuration(exp.startDate, exp.endDate)}
                        </div>
                      </div>
                    </span>
                  </span>
                  <span className='w-1/4 flex items-center justify-between'>
                    <span className=' opacity-60 text-sm'>
                      Work Exp {index + 1}
                    </span>
                    <span>
                      <IconButton
                        onClick={() => {
                          setVerify({ ...verify, [index]: 'yes' });
                          setWorkExperieneData([...workExperieneData, exp]);
                        }}
                        className='focus:outline-none'
                      >
                        <CheckCircle
                          htmlColor={
                            verify[index] === 'yes' ? '#76CE65' : 'inherit'
                          }
                        />
                      </IconButton>
                      <IconButton
                        onClick={() => {
                          setVerify({ ...verify, [index]: 'no' });
                          workExperieneData.splice(index, 1);
                          setWorkExperieneData([...workExperieneData]);
                        }}
                        className='focus:outline-none'
                      >
                        <Cancel
                          htmlColor={
                            verify[index] === 'no' ? '#CC0000' : 'inherit'
                          }
                        />
                      </IconButton>
                    </span>
                  </span>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default WorkExperiene;
